import React from "react";
import { Select, Typography, MenuItem } from "@mui/material";
import PropTypes from "prop-types";
import makeStyles from "@mui/styles/makeStyles";
import { visionURL } from "../../../config/environment";
import { useTranslation } from "react-i18next";
import usePermissions from "../../../redux/selectors/usePermissions";
import { validate } from "../../../routes/AdminRoutes";
import { sortBy } from "lodash";

export const appViewOptions = [
  {
    label: "Validate",
    key: "Validate",
    path: validate
  },
  {
    label: "New Admin Experience",
    key: "New Admin Experience",
    path: "/admin"
  },
  { label: "Admin Console", key: "Admin Console", path: "" },
  { label: "Data Manager", key: "Data Manager", path: "" },
  { label: "Reporting", key: "Reporting", path: "" },
  {
    label: "Learning Center",
    key: "New Learner Experience",
    path: "/learning-center"
  }
];

const useStyles = makeStyles(theme => ({
  dropdownValue: {
    textTransform: "uppercase",
    marginRight: theme.spacing(1),
    fontSize: "0.75rem"
  }
}));

export default function TopNavAppViewDropdown(props) {
  const { currentPath, userApps } = props;
  const permissions = usePermissions();
  const { t } = useTranslation();
  const classes = useStyles();
  let allowedApps = [];
  let selectedView;
  let appOption;

  if (!!userApps) {
    appViewOptions.forEach(viewOption => {
      const userApp = userApps.find(x => x.name === viewOption.key);
      if (userApp) {
        if (viewOption.path) {
          appOption = viewOption;
        } else {
          appOption = {
            label: viewOption.label,
            path: `${visionURL}/${userApp.path}`
          };
        }
        if (viewOption.key !== "New Admin Experience") {
          allowedApps.push(appOption);
        } else if (permissions.allowAdminExperience) {
          allowedApps.push(appOption);
        }
      }
    });
    selectedView = allowedApps.find(option =>
      currentPath.match(`${option.path}`)
    );
  }

  function handleViewChange(event) {
    window.location = event.target.value.path;
  }

  return (
    allowedApps.length > 1 && (
      <>
        <Select
          data-qa="nav-topnav-app-dropdown"
          value={selectedView}
          onChange={handleViewChange}
          renderValue={value => (
            <Typography
              variant="subtitle2"
              color="textPrimary"
              className={classes.dropdownValue}
              data-qa="nav-topnav-app-dropdown-label"
            >
              {t("learningCenterTopNav.allowedApps." + value.label)}
            </Typography>
          )}
        >
          {sortBy(allowedApps, ["label"]).map(viewOption => (
            <MenuItem key={viewOption.label} value={viewOption}>
              {t("learningCenterTopNav.allowedApps." + viewOption.label)}
            </MenuItem>
          ))}
        </Select>
      </>
    )
  );
}

TopNavAppViewDropdown.propTypes = {
  currentPath: PropTypes.string,
  userApps: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string, path: PropTypes.string })
  )
};
